import React, { useEffect, useState } from "react";
import Popup from "reactjs-popup";
import { summmaryAccountApiConfig } from "../config/apiConfig.js";
import {
  groupInfo,
  dataObject,
  popupInfo,
} from "../config/accountSummaryConfig.js";
import { SERVER_URL } from "../config/config";
import "./Form.css";
import "./TripForm.css";
import "./AutoSuggest.css";
import useForm from "./useForm";
import "./popup.css";
import { validate } from "../config/tripConfig";
import FormColumn from "./FormColumn.js";
import print from "print-js";
import { useLocation } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

// Redux
import { useDispatch } from "react-redux";

const SummaryOfAccount = ({ sessionObject }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [disableButton, setDisableButton] = useState(true);

  let variablesFromSession = {
    created_from: String(sessionObject.sessionVariables.branch_id),
    created_by: String(sessionObject.sessionVariables.user_id),
    login_user_id: String(sessionObject.sessionVariables.user_id),
    role_id: String(sessionObject.sessionVariables.role_id),
    company_id: sessionObject.sessionVariables.company_id ?? "1",
    fYear: sessionObject.sessionVariables.financial_year,
    fYearForFetch: sessionObject.sessionVariables.financial_year_for_fetch,
  };

  const myForm = useForm(
    "SummaryAccount",
    validate,
    { ...dataObject, ...variablesFromSession },
    summmaryAccountApiConfig
  );
  const isAdminUser = ["1", "2"].includes(
    String(sessionObject.sessionVariables.role_id)
  );
  const contentStyle = {
    maxWidth: "600px",
    width: "90%",
  };

  const formatDate = (isoDate) => {
    if (!isoDate) return "";
    return isoDate.split("T")[0]; 
  };

  const getSummaryTimeDisplay = () => {
    const rawDate =
      myForm.pageState.date_of_summary ||
      myForm.pageState.created_at ||
      myForm.pageState.created_date ||
      myForm.pageState.input_date;

    if (!rawDate) {
      return "";
    }

    const summaryDate = new Date(rawDate);

    if (Number.isNaN(summaryDate.getTime())) {
      return "";
    }

    return summaryDate.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
  };



  useEffect(() => {
    if (myForm.pageState.vehicle_no.length > 5) {
      setDisableButton(false);
    }
  }, [myForm.pageState.vehicle_no]);
  

  useEffect(() => {
    if (myForm.pageMode === 'view') return;

    const truck_hire = parseFloat(myForm.pageState.truck_hire) || 0;
    const other_charge = parseFloat(myForm.pageState.other_charge) || 0;
    const cash_received_by_driver =
      parseFloat(myForm.pageState.cash_received_by_driver) || 0;
    const labour_calculation =
      parseFloat(myForm.pageState.labour_calculation) || 0;
    const advance_bhada = parseFloat(myForm.pageState.advance_bhada) || 0;
    const tds_amount = parseFloat(myForm.pageState.tds_amount) || 0;
    const total_to_pay = parseFloat(myForm.pageState.total_to_pay) || 0;
    const rebate_calculation = parseFloat(myForm.pageState.rebate_calculation) || 0;
    const crossing_calculation = parseFloat(myForm.pageState.crossing_calculation) || 0;
  
    const delivery_maal_khata = parseFloat(myForm.pageState.delivery_maal_khata) || 0;
    const crossing_frieght = parseFloat(myForm.pageState.crossing_frieght) || 0;
    // const rebate_calculation = parseFloat(myForm.pageState.rebate_calculation) || 0;
    const pay_to_driver_temp = parseFloat(myForm.pageState.pay_to_driver) || 0;
  
    const gross_amount = Math.ceil(
      truck_hire + other_charge + cash_received_by_driver + labour_calculation
    );

    const pay_to_driver = gross_amount - advance_bhada - tds_amount;
  
    const net_amount = total_to_pay - rebate_calculation - crossing_calculation - pay_to_driver;
  
    const debit_balance = delivery_maal_khata + crossing_frieght + other_charge;
  
    const credit_balance = rebate_calculation + crossing_calculation + pay_to_driver_temp;
  
    const final_balance = debit_balance - credit_balance;
  
    myForm.setPageState((prevState) => ({
      ...prevState,
      gross_amount,
      pay_to_driver,
      net_amount,
      debit_balance,
      credit_balance,
      final_balance,
    }));
  }, [
    myForm.pageState.truck_hire,
    myForm.pageState.other_charge,
    myForm.pageState.cash_received_by_driver,
    myForm.pageState.labour_calculation,
    myForm.pageState.advance_bhada,
    myForm.pageState.tds_amount,
    myForm.pageState.total_to_pay,
    myForm.pageState.rebate_calculation,
    myForm.pageState.crossing_calculation,
    myForm.pageState.maal_khata_acc,
    myForm.pageState.freight_acc,
    myForm.pageState.deli_commision_acc,
    myForm.pageState.crossing_frieght,
    myForm.pageState.rebate_calculation,
    myForm.pageState.delivery_maal_khata,
    myForm.pageState.other_charge
  ]);  

  // React.useEffect(() => {
  //   // console.log(myForm.pageState);
  //   const defaultTripNo = location.state ?? "";
  //   console.log(defaultTripNo);
  //   if (defaultTripNo != "") {
  //     myForm.setPageState((oldPageState) => ({
  //       ...oldPageState,
  //       trip_no: defaultTripNo,
  //     }));

  //     const fakeKey = { key: "Enter" };
  //     myForm.getPageOnKeyEnter(fakeKey, defaultTripNo);
  //   }
  // }, []);

  // useEffect(() => {
  //   const id = myForm.pageState.id || "";
  
  //   myForm.setPageState((prevState) => ({
  //     ...prevState,
  //     trip_id: id, 
  //   }));
  // }, [myForm.pageState.id]); 
  

  const checkVisibilityCondition = (fieldInfo) => {
    // console.log("field info", fieldInfo, myForm.pageState.role_id)
    if (fieldInfo.name == "edit_button" && myForm.pageState.role_id != "1") {
      return false;
    } else if (
      fieldInfo.name == "delete_button" &&
      (myForm.pageState.role_id != "1" && myForm.pageState.role_id != "2")
    ) {
      return false;
    } else {
      return true;
    }
  };

  const checkDisabledCondition = (fieldInfo) => {
    // if (myForm.pageMode == "view") {
    //   return "disabled";
    // } else if (fieldInfo.name == "vehicle_no" || fieldInfo.name == "driver_name" || fieldInfo.name == "station_from_name" || fieldInfo.name == "booking_chalan_no" || fieldInfo.name == "trip_date" || fieldInfo.name == "delivery_maal_khata" || fieldInfo.name == "crossing_frieght" || fieldInfo.name == "total_article" || fieldInfo.name == "total_weight" || fieldInfo.name == "crossing_article" || fieldInfo.name == "delivery_article" || fieldInfo.name == "gri_no" || fieldInfo.name == "other_charge" || fieldInfo.name == "debit_balance" || fieldInfo.name == "credit_balance" || fieldInfo.name == "final_balance" || fieldInfo.name == "pay_to_driver" || fieldInfo.name == "rebate_calculation" || fieldInfo.name == "rebate_calculation" || fieldInfo.name == "crossing_calculation") {
    //   return "disabled";
    // }
    return myForm.pageMode === "view" ? "disabled" : "";
  };
  
  const getAdditionalInfoForSuggestionFetch = (fieldInfoObject) => {
    // if (fieldInfoObject.name == "vehicle_no"){
    //   return {"limit": "10"};
    // }
    let additionalInfoObject = {};
    if (fieldInfoObject.name == "station_from_name") {
      additionalInfoObject.is_branch = true;
      // additionalInfoObject.pay_type = myForm.pageState.pay_type;
      return additionalInfoObject;
    }
    return null;
  };

  console.log('sss', myForm.pageState)

  const calculateTotals = (temp_response) => {
    let totalPackagesNonCrossing = 0;
    let totalAmountNonCrossing = 0;
    let totalPackagesCrossing = 0;
    let totalAmountCrossing = 0;
    let totalWeight = 0;
    let bookingChalanNumbers = []; 
  
    if (temp_response.booking_chalan_info) {
      temp_response.booking_chalan_info.forEach((challan) => {

        totalWeight += challan.total_weight || 0;

        if (challan.booking_chalan_no) {
          bookingChalanNumbers.push(challan.booking_chalan_no);
        }

        if (challan.is_crossing_challan === false && Array.isArray(challan.bilty_info)) {
          challan.bilty_info.forEach((bilty) => {
            totalPackagesNonCrossing += bilty.no_of_package || 0;
            if (bilty.pay_type === 1) {
              totalAmountNonCrossing += parseFloat(bilty.total_amount) || 0;
            }
          });
        }
  
        if (challan.is_crossing_challan === true && Array.isArray(challan.bilty_info)) {
          challan.bilty_info.forEach((bilty) => {
            totalPackagesCrossing += bilty.no_of_package || 0;
            if (bilty.pay_type === 1) {
              totalAmountCrossing += parseFloat(bilty.total_amount) || 0;
            }
          });
        }
      });
    }

    return {
      delivery_article: totalPackagesNonCrossing,
      delivery_maal_khata: totalAmountNonCrossing,
      crossing_article: totalPackagesCrossing,
      crossing_frieght: totalAmountCrossing, 
      total_article: totalPackagesNonCrossing + totalPackagesCrossing, 
      total_weight: totalWeight, 
      booking_chalan_no: bookingChalanNumbers.join(","),
    };
  };

  const linkBilty = async (e, argResponse) => {
    console.log(e, argResponse);
    let temp_response;
    if (argResponse) {
      temp_response = argResponse;
    } else {
      if (myForm.pageState.trip_no == "" && e.key == "Enter") {
        myForm.makeFocusOnParticularField("vehicle_no");
        return;
      }

      if (e.key == "Enter") {
        const url =
          SERVER_URL +
          "/summary_of_account/get_trip_for_summary/?" +
          "trip_no=" +
          myForm.pageState.trip_no +
          "&station_to=" +
          myForm.pageState.created_from +
          "&fyear=" +
          myForm.pageState.fYearForFetch +
          "&companyId=" +
          myForm.pageState.company_id;

        const response = await fetch(url);

        if (!response.ok) {
          const temp_error = await response.json();
          if ("detail" in temp_error) {
            if (temp_error.detail == "Trip not found") {
              myForm.makeFocusOnParticularField("trip_no");
              return;
            }
            myForm.setPreviousPageMode(myForm.pageMode);
            myForm.setPageMode("error");
            myForm.setPopupError(String(temp_error.detail));
          } else {
            myForm.setPreviousPageMode(myForm.pageMode);
            myForm.setPageMode("error");
            myForm.setPopupError("Invalid Trip");
          }
          
          return;
        }
        temp_response = await response.json();
      }
    }

    console.log("Response", temp_response);

    const totals = calculateTotals(temp_response);
    const tripId = temp_response.id || "";

    myForm.setPageState((prevState) => {
      const updatedState = {
        ...prevState,
        ...temp_response,
        created_from: prevState.created_from,
        input_date: formatDate(temp_response.created_date),
        trip_id: tripId,
        deli_commission: temp_response.rebate_calculation,

        ...totals,
      };
      return updatedState;
    });

    myForm.makeFocusOnParticularField("delivery_maal_khata");
  };


  const handleDelete = async () => {
    const url = SERVER_URL + "/summary_of_account/" + myForm.pageState.id;
     
    const response = await fetch(url, { method: "DELETE" });
    if (!response.ok) {
      console.log("Not able to delete challan");
      return;
    }
    const temp_response = await response.json();
    if (temp_response === true) {
      myForm.setPageState({ ...dataObject, ...variablesFromSession });
      myForm.setPageMode("write");
      window.location.reload();
      return;
    }
  };


  return (
    <div className="challan-form-container">
      <div>
        <Popup
          // trigger={<button className="button"> Open Modal </button>}
          open={myForm.pageMode == "submitted" || myForm.pageMode == "error"}
          modal
          contentStyle={contentStyle}
          closeOnDocumentClick={false}
        >
          {(close) => (
            <div className="pop-up-container">
              <div className="pop-up-header">
                {" "}
                {myForm.pageMode == "submitted" ? (
                  <div>{popupInfo.success_header}</div>
                ) : (
                  <div>{popupInfo.error_header}</div>
                )}
                <div>
                  <a className="pop-up-close btn" onClick={close}>
                    &times;
                  </a>
                </div>
              </div>
              {myForm.pageMode == "submitted" ? (
                <div className="pop-up-content">
                  {popupInfo.success_title}
                  <br />
                  <div className="pop-up-fields">
                    <div className="pop-up-field">
                      <div className="pop-up-field-label">
                        {popupInfo.field_label_success}
                      </div>
                      <div className="pop-up-field-value">
                        {myForm.pageState[popupInfo.field_name_success]}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="pop-up-content">
                  {popupInfo.error_title}
                  <br />
                  <div className="pop-up-fields">
                    <div className="pop-up-field">
                      <div className="pop-up-field-label">
                        {popupInfo.field_label_error}
                      </div>
                      <div className="pop-up-field-value">
                        {myForm.popupError}
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div className="pop-up-actions">
                <button
                  className="pop-up-button"
                  onClick={() => {
                    if (myForm.pageMode == "submitted") {
                      // sessionObject.saveSessionVariableByField("last_bilty_no", {"last_bilty_no":myForm.pageState.bilty_no})
                      myForm.setPageState({
                        ...dataObject,
                        ...variablesFromSession,
                      });
                      myForm.setPageMode("write");
                      window.location.reload();
                      close();
                    } else {
                      if (myForm.previousPageMode != "") {
                        myForm.setPageMode(myForm.previousPageMode);
                        myForm.setPreviousPageMode("");
                      } else {
                        myForm.setPageMode("write");
                      }
                      close();
                    }
                  }}
                >
                  Okay
                </button>
              </div>
            </div>
          )}
        </Popup>
      </div>

      <div>
        <Popup
          // trigger={<button className="button"> Open Modal </button>}
          open={myForm.deletePopup}
          modal
          contentStyle={contentStyle}
          closeOnDocumentClick={false}
        >
          {(close) => (
            <div className="pop-up-container">
              <div className="pop-up-header">Are you sure want to delete?</div>
              <div className="pop-up-actions">
                <button
                  className="pop-up-button"
                  onClick={() => {
                    handleDelete();
                    myForm.setDeletePopup(false);
                    close();
                  }}
                >
                  Yes
                </button>
                <button
                  className="pop-up-button"
                  onClick={() => {
                    myForm.setDeletePopup(false);
                    close();
                  }}
                >
                  No
                </button>
              </div>
            </div>
          )}
        </Popup>
      </div>

      <div className="form-header">Summary Of Account</div>
      <div onSubmit={myForm.handleSubmit} className="form" noValidate>
        <div className="form-title">
          <div className="form-row">
            <label className="form-label">Summary No:</label>
            <input
              className="form-input"
              type="text"
              name="summary_of_account_no"
              placeholder=""
              value={myForm.pageState.summary_of_account_no}
              onChange={myForm.handleChange}
              onBlur={() => {}}
              onKeyPress={(a) =>
                myForm.getPageOnKeyEnter(a, myForm.pageState.summary_of_account_no)
              }
              disabled={checkDisabledCondition({ name: "summary_of_account_no" })}
              ref={(a) => myForm.storeInputReferenceForSelect(a, "summary_of_account_no")}
            />
            {myForm.internalValidationErrors["summary_of_account_no"] && (
              <p>{myForm.internalValidationErrors["summasummary_of_account_nory_no"]}</p>
            )}
            {myForm.pageMode == "view" && (
              <>
                {checkVisibilityCondition({ name: "edit_button" }) && (
                  <button
                    onClick={() => {
                      myForm.setPageMode("edit");
                    }}
                  >
                    Edit
                  </button>
                )}
              </>
            )}
          </div>
          <div className="form-row">
            <label className="form-label">Manual No:</label>
            <input
              className="form-input"
              type="text"
              name="manual_no"
              placeholder=""
              value={myForm.pageState.manual_no}
              onChange={myForm.handleChange}
              onBlur={() => {}}
              onKeyPress={(a) =>
                myForm.getPageOnKeyEnter(a, myForm.pageState.manual_no, undefined, "manual_no")
              }
              disabled={checkDisabledCondition({ name: "manual_no" })}
              ref={(a) => myForm.storeInputReferenceForSelect(a, "manual_no")}
            />
            {myForm.internalValidationErrors["summary_of_account_no"] && (
              <p>{myForm.internalValidationErrors["summasummary_of_account_nory_no"]}</p>
            )}
          </div>
          <div>
            Summary Date:{" "}
            <DatePicker
              dateFormat="dd-MM-yyy"
              selected={myForm.pageState.date_of_summary}
              onChange={(date) =>
                myForm.setPageStateByField("date_of_summary", date)
              }
              ref={(a) => myForm.storeInputReferenceForSelect(a, "date_of_summary")}
              disabled={checkDisabledCondition({ name: "date_of_summary" })}
              onKeyPress={(a) => {
                if (a.key == "Enter") {
                  myForm.makeFocusOnParticularFieldForItem(
                    "eway_bill_no",
                    0,
                    "eway_bill_no"
                  );
                }
              }}
            />
            {isAdminUser && (
              <span style={{ marginLeft: "12px" }}>
                Time: <input value={getSummaryTimeDisplay()} disabled />
              </span>
            )}
          </div>
          <div className="form-row">
            <label className="form-last_bilty">Last Summary No:</label>
            <label className="form-last_bilty">
              {myForm.pageState.last_summary_no}
            </label>
          </div>
        </div>
        <div className="form-input-content-block-0">
          <div className="form-field-left">
            <div className="form-row">
            <label className="form-label">Trip No:</label>
            <input
              className="form-input"
              type="text"
              name="trip_no"
              placeholder=""
              value={myForm.pageState.trip_no}
              onChange={myForm.handleChange}
              onBlur={() => {}}
              // onKeyPress={(a) =>
              //   myForm.getPageOnKeyEnter(a, myForm.pageState.trip_no)
              // }
              onKeyPress={(e) => {
                if(e.key == "Enter") {
                    e.preventDefault();
                    linkBilty(e);
                }
              }}
              disabled={checkDisabledCondition({ name: "trip_no" })}
              ref={(a) => myForm.storeInputReferenceForSelect(a, "trip_no")}
            />
            {myForm.internalValidationErrors["trip_no"] && (
              <p>{myForm.internalValidationErrors["trip_no"]}</p>
            )}
            
            </div>
            <FormColumn
              groupInfo={groupInfo}
              groupName="group-1"
              checkDisabledCondition={checkDisabledCondition}
              checkVisibilityCondition={checkVisibilityCondition}
              myFormObj={myForm}
              getAdditionalInfoForSuggestionFetch={
                getAdditionalInfoForSuggestionFetch
              }
              // disabled={true}
            />
          </div>
          <div className="form-field-right">
            <FormColumn
              groupInfo={groupInfo}
              groupName="group-2"
              checkDisabledCondition={checkDisabledCondition}
              checkVisibilityCondition={checkVisibilityCondition}
              myFormObj={myForm}
              getAdditionalInfoForSuggestionFetch={
                getAdditionalInfoForSuggestionFetch
              }
            />
          </div>
        </div>

        <div className="form-input-content-block-0">
          <div className="form-field-left">
            <div className="group-3-headings">
              <p>DEBIT</p>
              <p>AMOUNT</p>
            </div>
            <FormColumn
              groupInfo={groupInfo}
              groupName="group-3"
              checkDisabledCondition={checkDisabledCondition}
              checkVisibilityCondition={checkVisibilityCondition}
              myFormObj={myForm}
              getAdditionalInfoForSuggestionFetch={
                getAdditionalInfoForSuggestionFetch
              }
            />
          </div>

          <div className="form-field-right">
            <div className="group-3-headings">
              <p>CREDIT</p>
              <p>AMOUNT</p>
            </div>
            <FormColumn
              groupInfo={groupInfo}
              groupName="group-4"
              checkDisabledCondition={checkDisabledCondition}
              checkVisibilityCondition={checkVisibilityCondition}
              myFormObj={myForm}
              getAdditionalInfoForSuggestionFetch={
                getAdditionalInfoForSuggestionFetch
              }
            />
          </div>
        </div>
        <div className="form-footer">
          <button
            onClick={(e) => {
              console.log("PULKIT_VALA_Values", myForm.pageState);
              console.log("Values", myForm.pageState);
              myForm.setServerPrintNeeded(true);
              myForm.handleSubmit(e);
            }}
            type="button"
            ref={(a) => myForm.storeInputReferenceForSelect(a, "print_button")}
            className="btn btn-primary"
          >
            Print
          </button>
          <button
            onClick={myForm.handleSubmit}
            type="button"
            className="btn btn-primary"
            ref={(a) => myForm.storeInputReferenceForSelect(a, "save_button")}
          >
            Save
          </button>
          
          <button
            onClick={async () => {
              let url =
                SERVER_URL +
                "/trip/multiple_print/" +
                String(myForm.pageState.trip_no) +
                "?branch_id=" +
                String(myForm.pageState.created_from) +
                "&fyear=" +
                myForm.pageState.fYear_get +
                "&companyId=" +
                myForm.pageState.company_id;

              let response = await fetch(url, {
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                },
              }).then((r) => r.blob());
              console.log("response", response);
              print({
                printable: URL.createObjectURL(response),
                type: "pdf",
                showModal: false,
              });
            }}
            type="button"
            className="btn btn-primary"
            // ref={(a) => myForm.storeInputReferenceForSelect(a, "save_button")}
          >
            Print All Memo
          </button>

          {checkVisibilityCondition({ name: "delete_button" }) && (
            <button
             onClick={() => myForm.setDeletePopup(true)}
             className="btn btn-primary"
            >
              Delete
            </button>
          )}
          
        </div>
      </div>
    </div>
  );
};

export default SummaryOfAccount;
